type HttpError = {response?: {status?: number; data?: {message?: unknown}}}

const DEFAULT_MESSAGE = 'حساب کاربری شما غیرفعال شده است. برای پیگیری با پشتیبانی تماس بگیرید.'

/**
 * A system administrator switched the account off in «کاربران». Every sign-in route answers
 * HTTP 423 ACCOUNT_DISABLED (after the password, code or کارپوشه sign-in itself was right), so the
 * forms can say so instead of «wrong code» or a silent return to the sign-in page. Null for any
 * other answer.
 */
export const accountDisabledMessage = (error: unknown): string | null => {
  const response = (error as HttpError | undefined)?.response
  if (response?.status !== 423) return null
  const message = response.data?.message
  return typeof message === 'string' && message.trim() ? message : DEFAULT_MESSAGE
}
